import { render } from "./HausStep5.vue?vue&type=template&id=1b59d834&scoped=true"
import script from "./HausStep5.vue?vue&type=script&lang=js"
export * from "./HausStep5.vue?vue&type=script&lang=js"

import "./HausStep5.vue?vue&type=style&index=0&id=1b59d834&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b59d834"]])

export default __exports__